var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('jade-alert',{attrs:{"showIcon":"","variant":"positive","title":_vm.$t('title')}},[_vm._v(" "+_vm._s(_vm.$t('description', { acquirer: _vm.acquirer.payment_method }))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }